<template>
  <Card>
    <AjaxForm route="admin/TicketDepartment/Add">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6">
          <CustomInput type="text" name="title" label="عنوان" ></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <CustomInput type="number" name="sort" label="اولویت(عدد)" ></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-12">
          <CustomInput input_style="twoLine" type="textarea" label="توضیحات" name="description"></CustomInput>
        </div>
      </div>
      <div class="row">
        <div class="col-10 col-sm-8 col-md-5 mx-auto my-3">
          <button class="btn btn-info btn-block">ثبت دپارتمان تیکت</button>
        </div>
      </div>
    </AjaxForm>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {mapActions} from "vuex";
export default {
  name: "TicketDepartmentAdd",
  components: {CustomInput, AjaxForm, Card},
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('ثبت دپارتمان تیکت');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>